(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function updateCartCount(count) {
    var el = document.querySelector('[data-cart-count]');
    if (el) el.textContent = count;
  }

  function reloadCartItems() {
    fetch(window.location.href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.getElementById('cart-items');
        var oldItems = document.getElementById('cart-items');
        if (newItems && oldItems) {
          oldItems.innerHTML = newItems.innerHTML;
          attachQtyListeners();
        }
        var sub = doc.getElementById('cart-subtotal');
        var tot = doc.getElementById('cart-total');
        if (sub) document.getElementById('cart-subtotal').textContent = sub.textContent;
        if (tot) document.getElementById('cart-total').textContent = tot.textContent;
      });
  }

  function updateQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      if (qty === 0) {
        var line = document.querySelector('[data-key="' + key + '"]');
        if (line) line.remove();
        var sub = document.getElementById('cart-subtotal');
        var tot = document.getElementById('cart-total');
        var money = (cart.total_price / 100).toFixed(2);
        var fmt = '$' + money + ' MXN';
        if (sub) sub.textContent = fmt;
        if (tot) tot.textContent = fmt;
        if (cart.item_count === 0) window.location.reload();
      } else {
        var qtyEl  = document.querySelector('[data-qty="' + key + '"]');
        var priceEl = document.querySelector('[data-price="' + key + '"]');
        var item = cart.items.find(function (i) { return i.key === key; });
        if (qtyEl && item) qtyEl.textContent = item.quantity;
        if (priceEl && item) {
          var p = (item.line_price / 100).toFixed(2);
          priceEl.textContent = '$' + p + ' MXN';
        }
        var sub = document.getElementById('cart-subtotal');
        var tot = document.getElementById('cart-total');
        var money = (cart.total_price / 100).toFixed(2);
        var fmt = '$' + money + ' MXN';
        if (sub) sub.textContent = fmt;
        if (tot) tot.textContent = fmt;
      }
    });
  }

  function attachQtyListeners() {
    document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var delta = parseInt(btn.dataset.qtyChange, 10);
        var qtyEl = document.querySelector('[data-qty="' + key + '"]');
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var next = Math.max(0, current + delta);
        updateQty(key, next);
      });
    });

    document.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateQty(btn.dataset.remove, 0);
      });
    });
  }

  attachQtyListeners();
})();

  } catch(e) { console.error(e); }
})();
})();
